<script>
import Modal from '../../Modal.vue';
import axios from 'axios';

export default {
    components: {
        Modal
    },

    props: {
        requisitionId: Number,
        csrfToken: String,
        type: {
            type: String,
            default: 'requisition'
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
        async submitForm() {
            try {
                await axios.post(`/recruiter/requisitions/request-ad-creation/${this.requisitionId}`, {
                headers: {
                    'X-CSRF-TOKEN': this.csrfToken
                }
                });
                window.location.href = '/recruiter/requisitions/pending';
            } catch (error) {

            }
        }
    }
}
</script>

<template>
    <modal ref="modal" heading="Request ad creation">
        
        <div class="mb-4">
            <h5>Are you sure you want to move this {{ type }} to the ad creation phase?</h5>
        </div>

        <div class="grid-x grid-padding-x align-right">
            <div class="cell shrink">
                <button class="button success" type="button" @click="submitForm">OK</button>
            </div>

            <div class="cell shrink">
                <button class="button warning" type="button" @click="toggleModal">Close</button>
            </div>
        </div>
    </modal>
</template>

<style>

    form input, form button {
        display: inline-block;
    }

</style>